// src/pages/CompleteProfile.tsx
import React, { useState } from 'react';
import { Button } from '@/components/shadcn/ui/button';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/shadcn/ui/card';
import { Input } from '@/components/shadcn/ui/input';
import { Label } from '@/components/shadcn/ui/label';
import { useNavigate } from 'react-router-dom'; // Para navegação após o cadastro completo

interface CompleteProfileProps {
  userId: string; // ID do usuário que foi registrado no Firebase
}

const CompleteProfile: React.FC<CompleteProfileProps> = ({ userId }) => {
  const [nome, setNome] = useState<string>(''); // Estado para o nome
  const [dataNascimento, setDataNascimento] = useState<string>(''); // Estado para data de nascimento
  const [error, setError] = useState<string | null>(null); // Estado para erros
  const navigate = useNavigate(); // Hook para navegação entre páginas
  
  const API_URL = "/ws/api";
  // Função para lidar com o submit do formulário de completar perfil
  const handleCompleteProfile = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_URL}/api/usuarios/complete`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId,
          nome,
          dataNascimento,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        alert('Perfil completado com sucesso!');
        navigate("/kanban"); // Navega para a home ou para onde desejar
      } else {
        alert(`Erro ao completar o perfil: ${data.message}`);
      }
    } catch (err: any) {
      setError(err.message);
      alert(`Erro: ${err.message}`);
    }
  };

  return (
    <div className="flex min-h-screen bg-indigo-200 justify-center items-center">
      <Card className="w-[450px] h-[400px]">
        <CardHeader>
          <CardTitle>Complete seu perfil</CardTitle>
        </CardHeader>
        <CardContent>
          <form>
            <div className="grid w-full items-center gap-6">
              <div className="flex flex-col space-y-1.5">
                <Label htmlFor="nome">Nome</Label>
                <Input
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  type="text"
                  placeholder="Nome Completo"
                  required
                />
              </div>
              <div className="flex flex-col space-y-1.5">
                <Label htmlFor="dataNascimento">Data de Nascimento</Label>
                <Input
                  value={dataNascimento}
                  onChange={(e) => setDataNascimento(e.target.value)}
                  type="date"
                  required
                />
              </div>
              <CardFooter className="mt-6 flex justify-between">
                <Button
                  type="submit"
                  onClick={handleCompleteProfile}
                  className="bg-indigo-500 hover:bg-indigo-800 w-[130px]"
                >
                  Completar
                </Button>
              </CardFooter>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default CompleteProfile;
